import { createTooltipTheme } from './createTooltipTheme';
import { colors } from '../../../constants/colors';

export const DarkGrayTheme = createTooltipTheme({
  name: 'dark-gray-theme',
  fontColor: '#fff',
  backgroundColor: colors.darkGray,
  borderColor: 'rgba(0, 0, 0, 0)',
  boxShadow: 'none',
  borderRadius: '8px',
});
